import React from 'react'
import PropTypes from 'prop-types'
import TruckImage from '../../svg/Truck.svg'
import clsx from 'clsx'
import WarningCard from '../../pages/CreateRequestStepper.js/components/WarningCard'
import { useNetworkStatus } from '../../utils/networkStatus'
import { isEnvForcedMaintenanceMode } from '../../utils/maintenanceEnv'

const LoginLayout = ({ children, isLoginPath, hasTruckImage, hasScroll }) => {
    const { isOffline } = useNetworkStatus()
    const forceMaintenance = isEnvForcedMaintenanceMode()
    const loginUnavailable = isOffline || forceMaintenance
    const loginUnavailableMessage = forceMaintenance
        ? 'LiftOne Now under maintenance, you will be able to login once we are back online'
        : 'You will be able to sign in once you’re back online.'
    if (!children) return null

    if (!isLoginPath) return children

    return (
        <main
            className={clsx(
                'w-screen h-screen max-h-screen bg-black90 overflow-auto items-center justify-center sm:py-0 sm:p-0 p-4 flex',
            )}
        >
            <div
                className={clsx(
                    hasTruckImage ? 'lg:h-148.5 h-auto ' : 'h-auto',
                    hasScroll && 'm-auto',
                    'lg:w-260 sm:w-4/5 w-full h-auto transition-all rounded-3xl border border-black70 bg-black80 flex flex-row items-center justify-start overflow-hidden',
                )}
            >
                {hasTruckImage && (
                    <div className="lg:w-1/2 w-auto lg:block hidden ">
                        <img
                            src={TruckImage}
                            loading="lazy"
                            className="w-full h-full object-cover"
                        />
                    </div>
                )}
                <div
                    className={clsx(
                        hasTruckImage
                            ? 'lg:w-1/2 w-full h-full'
                            : 'w-full h-auto',
                    )}
                >
                    {children}
                    {loginUnavailable && (
                        <div className="fixed bottom-0 right-0 w-full p-0 z-50">
                            <WarningCard
                                error={loginUnavailableMessage}
                                warningSize={26}
                                closeButton
                            />
                        </div>
                    )}
                </div>
            </div>
        </main>
    )
}

LoginLayout.propTypes = {
    children: PropTypes.node,
    hasTruckImage: PropTypes.bool,
    isLoginPath: PropTypes.bool,
    hasScroll: PropTypes.bool,
}

export default LoginLayout
